// extracted by mini-css-extract-plugin
export default {"card-container":"card-view-grid_card-container__KFVBn","card-child-ghost":"card-view-grid_card-child-ghost__PB6P3"};